// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"356":"e0c06bf8","571":"67674710","903":"9a3a623f","921":"fca78745"}[chunkId] + ".chunk.js";
};